import { INDEED, JOVEO, POOL } from '@/types/channels';

import { PoolForm } from '../pool';
import { DefaultForm } from './default-form';
import { IndeedForm } from './indeed-form';
import { JoveoForm } from './joveo-form';
interface ChannelSwitcherProps {
  channelSlug: string;
}

export function ChannelSwitcher({ channelSlug }: ChannelSwitcherProps) {
  switch (channelSlug) {
    case JOVEO:
      return <JoveoForm />;
    case INDEED:
      return <IndeedForm />;
    case POOL:
      return <PoolForm />;
    default:
      return <DefaultForm />;
  }
}
